import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, publishLast, refCount, take } from 'rxjs/operators';
import { Validation, ContractType, PersonType } from '../../models';
import { ErrorMessage, CssClass } from '../../constants';
import { GenderValidationService } from '../component/gender-validation.service';
import { PrimaryDOBValidationService } from '../component/primary-dob-validation.service';
import { PostalCodeValidationService } from '../component/postal-code-validation.service';
import { EmailValidationService } from '../component/email-validation.service';
import { PrivacyPolicyValidationService } from '../component/privacy-policy-validation.service';
import { InsurersValidationService } from '../component/additional-insurer-validation.service';
import { TelephoneValidationService } from '../component/telephone-validation.service';
//import { DeferredConfigModel } from '../../models';
//import { SessionInfoModel } from '../../models/start-up-config/session-info-model';
//import { LocalDataCacheService } from '../storage';

@Injectable({
  providedIn: 'root'
})
export class ValidationUiService {
  constructor(private genderValidationService: GenderValidationService,
    private primaryDOBValidationService: PrimaryDOBValidationService,
    private postalCodeValidationService: PostalCodeValidationService,
    private emailValidationService: EmailValidationService,
    private telephoneValidationService: TelephoneValidationService,
    private privacyPolicyValidationService: PrivacyPolicyValidationService,
    private insurersValidationService: InsurersValidationService) {

  }


  isValid(contractType: ContractType, isPrivacyPolicyChecked: boolean, isUpaEnable: boolean = false) {
    let validation = true;
    let genderValidation = this.genderValidationService.isInValid(contractType);
    let primaryDOBValidation = this.primaryDOBValidationService.isInValid(contractType);
    let addInsurers = this.insurersValidationService.isInValid(contractType);
    let postalCodeValidation = this.postalCodeValidationService.isInValid(contractType);
    let emailValidation = this.emailValidationService.isInValid(contractType);
    if (isUpaEnable) {
      emailValidation = false;
    }
    let telephoneValidation = this.telephoneValidationService.isInValid(contractType);
    let policyCheck = this.privacyPolicyValidationService.isInValid(isPrivacyPolicyChecked)
    if (genderValidation || primaryDOBValidation || postalCodeValidation || emailValidation || telephoneValidation || policyCheck || addInsurers) {
      validation = false
    }
    return validation
  }

  predictZipCode(zipCode: string) {
      this.postalCodeValidationService.predictZipCode(zipCode);
  }


}
